import { Dialog } from "primereact/dialog";
import { baseUrl } from "../../shared/Fetch";
import { Button } from "primereact/button";
import { useEffect, useState } from "react";
import mammoth from "mammoth";
import { Card } from "primereact/card";


interface IProps {
    open: boolean;
    singleData: any;
    onClose: () => void;
    searchQuery?: string;
    toast: any;
}

export const ViewPdf = (props: IProps) => {
    const [html, setHtml] = useState<string>("");
    const [isPdf, setIsPdf] = useState<boolean>(false);
    const [pdfUrl, setPdfUrl] = useState<string | null>(null);

    const downLoadInvoice = async (rowData: any) => {
        const params = {
            method: "GET",
            headers: {
                'Content-Type': 'application/pdf',
                'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
            }
        };
        try {
            const response = await fetch(`${baseUrl}${"Resume_Mast/download"}?path=${rowData.consultant_Resume_Path}`, params);
            if (response.status === 200) {
                const blob = await response.blob();
                const href = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                // a.download = `${rowData.consultant_Resume_Path.split(".")[0]}.docx`;
                a.download = rowData.consultant_Resume_Path;
                a.href = href;
                a.click();
                a.href = '';
            } else if (response.status === 400) {
                const message = await response.text();
                props.toast.current.show({ severity: 'error', detail: message, life: 3000 });
            }
        } catch {
            props.toast.current.show({ severity: 'error', detail: 'Something went Wrong', life: 3000 });
        }
    };

    const onClose = () => {
        setHtml("");
        setIsPdf(false);
        setPdfUrl(null);
        props.onClose();
    };

    const highlightWord = (html: any, word: string) => {
        const regex = new RegExp(`\\b(${word})\\b`, "gi"); // case-insensitive, full word match
        return html.replace(regex, `<span style="background-color: yellow">${word}</span>`);
    };

    async function fetchAndConvert() {
        if (props.singleData.consultant_Resume_Path.includes(".pdf")) {
            const response = await fetch(baseUrl + `Resume_Mast/download?path=${encodeURIComponent(props.singleData.consultant_Resume_Path)}${props.searchQuery?.trim() !== "" ? `&searchQuery=${encodeURIComponent(props.searchQuery || '')}` : ''}`);
            if (!response.ok) {
                console.error("Failed to fetch PDF");
                return;
            }
            const blob = await response.blob();
            const blobUrl = URL.createObjectURL(blob);
            setIsPdf(true);
            setPdfUrl(blobUrl);
        } else {
            const response = await fetch(baseUrl + `Resume_Mast/download?path=${encodeURIComponent(props.singleData.consultant_Resume_Path)}${props.searchQuery?.trim() !== "" ? `&searchQuery=${encodeURIComponent(props.searchQuery || '')}` : ''}`);
            const arrayBuffer = await response.arrayBuffer();
            const { value } = await mammoth.convertToHtml({ arrayBuffer });

            if (props.searchQuery !== undefined && props.searchQuery !== null && props.searchQuery.trim() !== "") {
                let words = props.searchQuery.trim().toLowerCase();

                if (words.includes("and")) {
                    words = words.split("and").join(" ").trim();
                }
                if (words.includes("or")) {
                    words = words.split("or").join(" ").trim();
                }
                if (words.includes("(")) {
                    words = words.split("(").join(" ").trim();
                }
                if (words.includes(")")) {
                    words = words.split(")").join(" ").trim();
                }
                if (words.includes(",")) {
                    words = words.split(",").join(" ").trim();
                }
                if (words.includes('"')) {
                    words = words.split('"').join(" ").trim();
                }

                // const highlightedHtml = highlightWord(value, props.searchQuery);
                // setHtml(highlightedHtml);

                let newHighlightedHtml = value;
                for (const word of words.split(" ")) {
                    if (word.trim() === "") continue;

                    let newWord1 = [word.trim().split("")[0].toUpperCase(), word.trim().split("").splice(1)].flat().join("");
                    let newWord2 = word.trim().toUpperCase();
                    let newWord3 = word.trim().toLowerCase();
                    let highlightedHtml1 = highlightWord(newHighlightedHtml, newWord1);
                    let highlightedHtml2 = highlightWord(highlightedHtml1, newWord2);
                    let highlightedHtml3 = highlightWord(highlightedHtml2, newWord3);
                    newHighlightedHtml = highlightedHtml3;
                }

                setHtml(newHighlightedHtml);
            } else {
                setHtml(value);
            }
        }
    };

    useEffect(() => {
        if (props.open) {
            fetchAndConvert();
        }
    }, [props.open]);


    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Resume" modal className="p-fluid" onHide={onClose}>
            <Button label="Download Resume" style={{ width: "13rem" }} icon="pi pi-download" className="p-button-outlined" onClick={() => downLoadInvoice(props.singleData)} />
            <Card>
                {isPdf === false && <div dangerouslySetInnerHTML={{ __html: html }} />}
                {isPdf === true && <iframe src={pdfUrl || ""} width="100%" height="600px"></iframe>}
            </Card>
        </Dialog>
    );
}